import { CarrierLogo } from '../../members/components/CarrierLogo'

interface PlanChipProps {
  planName: string;
  carrierLogo: string;
  carrierName: string;
  premium?: string;
}

export function PlanChip ({
  planName,
  carrierLogo,
  carrierName,
}: PlanChipProps) {
  return (
    <div className='flex items-start gap-2'>
      {carrierLogo && carrierLogo.length > 0 && (
        <CarrierLogo aria-hidden src={carrierLogo} />
      )}
      <div className='min-w-0 flex-1'>
        <div className='text-gray-800 body-sm-bold leading-tight mb-2 break-words'>
          {planName}
        </div>
        <div className='body-sm leading-tight text-gray-500 break-words'>{carrierName}</div>
      </div>
    </div>
  )
}
